<template>
    <flickity class="project-carousel" :options="flickityOptions">
        <slot></slot>
    </flickity>
</template>

<script>
    import Flickity from 'vue-flickity';

    export default {
        name: "ProjectCarousel",
        components: {
            Flickity
        },
        computed: {
            flickityOptions() {
                return {
                    prevNextButtons: false,
                    pageDots: true,
                    wrapAround: true
                }
            }
        }
    }
</script>

<style scoped>

</style>